<template>
    <div class="sale">
        <el-form :model="searchData" :inline="true" size="small">
            <el-form-item>
                <el-input
                    v-model="searchData.name"
                    placeholder="客户名称/联系人"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-input
                    v-model="searchData.contact_mobilephone"
                    placeholder="手机号"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-search" @click="GetSearch">搜索</el-button>
            </el-form-item>
        </el-form>
        <div class="card">
            <div class="list" v-loading="customerData.loading.list">
                <el-row class="list-control">
                    <el-col :span="12">
                        <el-select v-model="searchData.id" size="small" @change="GetSearch">
                            <el-option
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                v-for="item in seaData.list"
                            >
                            </el-option>
                        </el-select>
                        <template v-if="$store.state.userInfo.identity === 1">
                            <el-upload
                                action=""
                                :show-file-list="false"
                                :http-request="ImportCustomer"
                                class="list-upload"
                            >
                                <el-button size="small">导入客户</el-button>
                            </el-upload>
                        </template>
                    </el-col>
                    <el-col :span="12" class="t-right">
                        <el-button-group>
                            <template v-if="$store.state.userInfo.identity === 1">
                                <el-button
                                    size="small"
                                    :disabled="
                                        !componentParam.customerDistribute.row.customers.length
                                    "
                                    @click="distributeCustomer"
                                    >分配</el-button
                                >
                            </template>
                        </el-button-group>
                        <template v-if="$store.state.userInfo.identity === 1">
                            <el-button
                                size="small"
                                type="primary"
                                icon="el-icon-circle-plus"
                                @click="DetailCustomer"
                                >客户</el-button
                            >
                        </template>
                    </el-col>
                </el-row>
                <el-alert
                    :title="
                        '已选中 ' +
                        componentParam.customerDistribute.row.customers.length +
                        ' 名客户'
                    "
                    type="info"
                    class="list-alert"
                ></el-alert>
                <div class="list-table">
                    <el-table
                        ref="customerTable"
                        :data="customerData.list"
                        stripe
                        style="width: 100%"
                        reserve-selection
                        @selection-change="SelectionCustomer"
                    >
                        <template v-if="$store.state.userInfo.identity === 1">
                            <el-table-column type="selection" width="50"></el-table-column>
                        </template>
                        <el-table-column label="名称" width="360">
                            <template slot-scope="scope">
                                <el-link
                                    type="primary"
                                    :underline="false"
                                    @click="DetailCustomer(scope.row)"
                                    >{{ scope.row.customer.contact_name
                                    }}{{
                                        scope.row.customer.name === scope.row.customer.contact_name
                                            ? null
                                            : '（' + scope.row.customer.name + '）'
                                    }}</el-link
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="地区">
                            <template slot-scope="scope"
                                >{{ scope.row.customer.province }}{{ scope.row.customer.city
                                }}{{ scope.row.customer.county }}</template
                            >
                        </el-table-column>
                        <el-table-column label="创建时间" width="180">
                            <template slot-scope="scope">{{
                                scope.row.customer.created_at
                            }}</template>
                        </el-table-column>
                        <el-table-column width="60" fixed="right">
                            <template slot-scope="scope">
                                <div class="t-right">
                                    <el-link
                                        type="primary"
                                        :underline="false"
                                        @click="receiveCustomer(scope.row)"
                                        >领取</el-link
                                    >
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :current-page.sync="customerData.pages.page"
                        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                        :page-size="customerData.pages.pagesize"
                        :total="customerData.pages.total"
                        @size-change="GetSize"
                        @current-change="GetCurrent"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <v-CustomerDistribute
            :detailParam="componentParam.customerDistribute"
            v-if="componentParam.customerDistribute.visible"
        />
        <v-CustomerDetail
            :detailParam="componentParam.customerDetail"
            v-if="componentParam.customerDetail.visible"
        />
        <v-CustomerForm
            :detailParam="componentParam.customerForm"
            v-if="componentParam.customerForm.visible"
        />
    </div>
</template>

<script>
import { AreaData } from '@/plugin/Area'
// 分配客户
import CustomerDistribute from '@/components/customer/Distribute'
import CustomerDetail from '@/components/customer/Detail'
import CustomerForm from '@/components/customer/Form'
export default {
    components: {
        'v-CustomerDistribute': CustomerDistribute,
        'v-CustomerDetail': CustomerDetail,
        'v-CustomerForm': CustomerForm
    },
    inject: ['reload'],
    mixins: [AreaData],
    data() {
        return {
            seaData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999,
                    total: 0
                }
            },
            searchData: {
                id: null,
                name: null,
                contact_mobilephone: null
            },
            customerData: {
                loading: {
                    list: false
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 10,
                    total: 0
                }
            },
            componentParam: {
                customerDistribute: {
                    visible: false,
                    row: {
                        sea_id: null,
                        customers: []
                    }
                },
                customerDetail: {},
                customerForm: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetSea()
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {
        // 公海
        GetSea() {
            this.$request({
                url: '/api/v1/customer_sea',
                params: {
                    order: 'asc',
                    ...this.seaData.pages
                }
            }).then(res => {
                if (!res.status) {
                    this.seaData.list = res.data.list
                    if (res.data.list.length) {
                        this.searchData.id = this.componentParam.customerDistribute.row.sea_id =
                            res.data.list[0].id
                        this.GetCustomer()
                    }
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        // 查询
        GetSearch() {
            this.customerData.pages.page = 0
            this.GetCustomer()
        },
        GetCustomer() {
            this.customerData.loading.list = true
            this.$request({
                url: '/api/v1/customer_sea_get_customers',
                params: {
                    ...this.searchData,
                    ...this.customerData.pages
                }
            }).then(res => {
                this.customerData.loading.list = false
                if (!res.status) {
                    this.customerData.list = res.data.list
                    this.customerData.pages.total = parseInt(res.data.total)
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetSize(val) {
            this.customerData.pages.pagesize = val
            this.GetCustomer()
        },
        GetCurrent(val) {
            this.customerData.pages.page = val
            this.GetCustomer()
        },
        // 导入
        ImportCustomer(obj) {
            var requestData = new FormData()
            requestData.append('report', obj.file)
            requestData.append('customer_sea_id', this.searchData.id)
            this.$request({
                url: '/api/v1/customer_sea_import',
                method: 'POST',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: requestData
            }).then(res => {
                this.$message({
                    message: res.data || (res.status ? '操作失败' : '操作成功'),
                    type: res.status ? 'error' : 'success'
                })
                if (!res.status) {
                    this.reload()
                }
            })
        },
        // 多选
        SelectionCustomer(val) {
            this.componentParam.customerDistribute.row.customers = []
            val.forEach(row => {
                this.componentParam.customerDistribute.row.customers.push(row.customer_id)
            })
        },
        // 分配客户
        distributeCustomer() {
            this.componentParam.customerDistribute.visible = true
        },
        // 领取客户
        receiveCustomer(row) {
            let loacl_receive_at = localStorage.getItem('receive_at')
            if (
                this.$store.state.userInfo.id != 38 &&
                Date.parse(new Date()) - loacl_receive_at <= 600000 &&
                this.searchData.id === 1
            ) {
                this.$message({
                    message: '不要太贪心哦，请过一会儿再领取~',
                    type: 'error'
                })
                return
            }
            this.$confirm('领取资源后一小时内必须跟进。杜绝浪费，从我做起 ^_^', '警告', {
                confirmButtonText: '确 定',
                cancelButtonText: '取 消'
            })
                .then(() => {
                    this.$request({
                        url: '/api/v1/receivecustomer',
                        params: {
                            customers: '[' + row.customer_id + ']'
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            // 存储领取时间
                            localStorage.setItem('receive_at', Date.parse(new Date()))
                            this.reload()
                        }
                    })
                })
                .catch(() => {})
        },
        // 客户详情 增加&修改
        DetailCustomer(row) {
            if (row.customer && row.customer.id) {
                this.componentParam.customerDetail = {
                    visible: true,
                    row: {
                        customer_id: row.customer.id
                    }
                }
            } else {
                this.componentParam.customerForm = {
                    visible: true,
                    row: {
                        customer_sea_id: this.searchData.id
                    }
                }
            }
        },
        DelCustomer(row) {
            this.$confirm('此操作将永久删除当前数据, 是否继续?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$request({
                        url: '/api/v1/customer_sea_del_customers',
                        params: {
                            id: row.customer_sea_id,
                            customers: JSON.stringify(row.customer_id.toString().split(' '))
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.GetSearch()
                        }
                    })
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/card.less';
@import '~@/assets/css/list.less';
</style>
